import { Card, Col, Dropdown } from "react-bootstrap"
import face1 from "../../../../../Utils/assets/img/faces/5.jpg"
import face2 from "../../../../../Utils/assets/img/faces/6.jpg"
import face3 from "../../../../../Utils/assets/img/faces/7.jpg"
import { GetRequest } from "../../../../../Utils/hooks/ApiHandler"
import { useGetEssentials } from "../../../../../Utils/hooks/useGetEssentials"
import { useEffect, useState } from "react"
import nodata from "../../../../../Utils/assets/img/leads_no_data_found_removebg.png"

const DEFAULT_AVATAR = [face1, face2, face3]

export const TopSalesPerformers = () => {

    const categoryGradients = [
        'rgba(99, 102, 241, 0.18)',
        'rgba(16, 185, 129, 0.18)',
        'rgba(245, 158, 11, 0.18)',
        'rgba(236, 72, 153, 0.18)',
        'rgba(241, 99, 99, 0.18)',
        'rgba(184, 99, 241, 0.18)',
    ]

    const { customerId, headers, extras } = useGetEssentials()
    // Component state for selecting the timeframe
    const [selectedPeriod, setSelectedPeriod] = useState("today");
    const [topPerformers, setTopPerformers] = useState(null)

    const duration = [
        { value: 'today', title: "Today" },
        { value: 'week', title: "This Week" },
        { value: 'month', title: "This Month" }
    ]

    const fetchTopPerformers = async () => {
        try {
            const res = await GetRequest(`dashboard/topPerformer/${customerId}/${selectedPeriod}`, { headers }, extras)
            if (res.status === 'fail' || res.success === false) {
                setTopPerformers(null)
                return
            }
            setTopPerformers(res.data)
        } catch (error) {
            return
        }
    }

    useEffect(() => {
        fetchTopPerformers()
    }, [selectedPeriod])



    return (
        <Col lg={4}>
            <Card className="h-100 rounded-3 p-0 position-relative" style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}>
                <Card.Body className="p-3 d-flex flex-column justify-content-between h-100">
                    <div>
                        <div className="d-flex align-items-center justify-content-between mb-1">
                            <span className="fw-semibold text-dark" style={{ fontSize: '14.5px' }}>
                                Top Salesperformers
                            </span>
                            <Dropdown as="div" align={"end"} >
                                <Dropdown.Toggle
                                    as="button"
                                    className="btn btn-light d-flex align-items-center gap-2 px-2 py-1 text-muted no-arrow"
                                    style={{ fontSize: '12px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef', textTransform: 'capitalize' }}
                                >
                                    <span className="text-capitalize">{selectedPeriod}</span>
                                    <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    className="shadow"
                                    style={{
                                        width: "10rem",
                                        padding: "8px 0px",
                                        right: "3.4rem",
                                    }}
                                >
                                    {
                                        duration?.map(c => (
                                            <Dropdown.Item
                                                href="#"
                                                className="d-flex align-items-center"
                                                onClick={() => setSelectedPeriod(c.value)}
                                            >
                                                {c.title}
                                            </Dropdown.Item>
                                        ))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>
                            Highest volume & conversion rate out of 30
                        </span>

                        <hr className="my-2" style={{ opacity: 0.1, backgroundColor: "#000" }} />

                        {/* RANKINGS LIST */}
                        <div className="position-relative d-flex flex-column gap-2">
                            {topPerformers ?
                                topPerformers.map((person, index) => {
                                    return <CategoryCard
                                        key={`${person.name}${index}`}
                                        person={person}
                                        gradient={categoryGradients[index]}
                                        fallbackImg={DEFAULT_AVATAR[index % DEFAULT_AVATAR.length]}
                                    />
                                })
                                :
                                <>
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ position: "absolute", left: "24%" }}
                                    >
                                        <img
                                            src={nodata}
                                            alt=""
                                            style={{ width: "17rem", marginTop: "0" }}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Col>

    )
}


const CategoryCard = ({ person, gradient, fallbackImg }) => {
    // derive numeric value from person.deals (e.g., "14 Deals")
    const numeric = (() => {
        if (!person || person.deals === undefined || person.deals === null) return 0;
        if (typeof person.deals === 'number') return person.deals;
        const match = String(person.deals).match(/(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
    })();

    const pct = Math.min(Math.round((numeric / 30) * 100), 100);
    const avatarSrc = person?.img ? person.img : fallbackImg;

    return (
        <div
            className='d-flex align-items-center justify-content-between p-2 rounded-3'
            style={{ position: 'relative', overflow: 'hidden', background: gradient }}
        >
            {/* fill overlay acting as the progress background */}
            <div
                aria-hidden
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: `${pct}%`,
                    background: gradient,
                    pointerEvents: 'none',
                }}
            />

            <div style={{ position: 'relative', zIndex: 1 }} className='d-flex align-items-center gap-2'>
                <img
                    src={avatarSrc}
                    alt={person.name}
                    className="rounded-circle object-fit-cover"
                    style={{ width: "32px", height: "32px", border: "1px solid #e2e8f0" }}
                />
                <div className='d-flex flex-column gap-1 justify-content-start'>
                    <span className=" text-dark d-block" style={{ fontWeight: 600, fontSize: "12.5px", lineHeight: "1.2" }}>
                        {person.name}
                    </span>
                </div>
            </div>

            <div style={{ position: 'relative', zIndex: 1, width: 120 }}>
                <strong className="fw-medium d-block text-dark" style={{ fontSize: "14.5px", textAlign: 'right' }}>
                    {person.deals}
                </strong>
            </div>
        </div>
    )
}